// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"2441":"818548e7203b55d23717","5862":"142cd48ca8ec32e57725","6189":"9da92cab3c64c96d05a8"}[chunkId] + "";
};